import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import PlusIcon from "../../../../../assets/icons/PlusIcon";
import Spinner from "../../../../../assets/icons/Spinner";
import label from "../../../../../i18n/label";
import Message from "../../../../../i18n/Message";
import ModalDialog from "../../../../shared/ModalDialog";
import backend from "../../../../../backend/backend";
import Notify from "../../../../shared/Notify";

import "./CreateWebpageDialog.scss";

const CreateWebpageDialog = ({ workspaceId, kbaseId, onClose, onSuccess }) => {
  const intl = useIntl();
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState("");
  const [includeSubPages, setIncludeSubPages] = useState(false);
  const [error, setError] = useState("");
  const [formElem, setFormElem] = useState(null);

  useEffect(() => {
    // Clear error when URL changes
    if (error) {
      setError("");
    }
  }, [url]);

  const onCreate = () => {
    if (!formElem?.checkValidity()) {
      formElem?.reportValidity();
      return;
    }

    setLoading(true);
    setError("");

    // Extract a name from the URL (domain or path)
    let name = url;
    try {
      const urlObj = new URL(url);
      name = urlObj.hostname + (urlObj.pathname !== "/" ? urlObj.pathname : "");
    } catch (e) {
      // If URL parsing fails, use the URL as name
      name = url;
    }

    backend
      .createKBAsset(workspaceId, kbaseId, {
        name,
        url,
        assetType: "URL",
        includeSubPages,
      })
      .then((resp) => {
        console.log("Created webpage asset", resp);
        setLoading(false);
        Notify.success(label(intl, "webpage_created"));
        onClose();
        onSuccess && onSuccess();
      })
      .catch(async (err) => {
        console.error("Webpage creation failed", err);
        if (err.json) {
          const errorJson = await err.json();
          const errorMsg = errorJson?.message
            ? label(intl, errorJson.message)
            : label(intl, "error_creating_webpage");
          setError(errorMsg);
        } else {
          setError(label(intl, "error_creating_webpage"));
        }
        setLoading(false);
      });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    onCreate();
  };

  return (
    <ModalDialog onClose={onClose} className="create_webpage_dialog">
      <div className="modal_title">
        <Message id="add_webpage_title" />
      </div>
      <form onSubmit={onSubmit} ref={(val) => setFormElem(val)}>
        <div className="dialog_body">
          <div className="form-group">
            <label>
              <Message id="webpage_url" />
            </label>
            <input
              className={`form-control ${error ? "is-invalid" : ""}`}
              type="url"
              required
              placeholder={label(intl, "webpage_url_placeholder")}
              onChange={(e) => setUrl(e.target.value)}
              value={url}
              readOnly={loading}
              autoFocus
            />
          </div>
          <div className="form-group mt-3">
            <label className="form-check-label d-flex align-items-center">
              <input
                type="checkbox"
                className="form-check-input me-2"
                checked={includeSubPages}
                onChange={(e) => setIncludeSubPages(e.target.checked)}
                disabled={loading}
              />
              <span>
                <Message id="include_subpages" />
              </span>
            </label>
            <div className="form-text text-muted">
              <Message id="include_subpages_description" />
            </div>
          </div>
          {error && <div className="error_message mt-2">{error}</div>}
        </div>

        <div className="buttons">
          <button
            className="btn bg-gradient-dark"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <Spinner size="18" />
            ) : (
              <PlusIcon color="#fff" strokeWidth="2" size="18" />
            )}
            <Message id="add_webpage_button" />
          </button>
          <button className="btn no-btn" onClick={onClose} type="button">
            <Message id="cancel" />
          </button>
        </div>
      </form>
    </ModalDialog>
  );
};

export default CreateWebpageDialog;
